import script from "./ViewUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewUserModal.vue?vue&type=script&setup=true&lang=js"

import "./ViewUserModal.vue?vue&type=style&index=0&id=0f97f477&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f97f477"]])

export default __exports__